module.exports = __webpack_public_path__ + "img/muflis-teenpatti.7e8a5b0.jpg";